import {IListViewField} from "../ILIstViewField";
import {IAppEntity} from "../../../config/entities";
import CustomStore from "devextreme/data/custom_store";
import {Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel} from "devextreme-react/data-grid";
import {DataGrid, DateRangeBox, Popup, Toolbar, Tooltip} from "devextreme-react";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {IDataGridLoadOptionsFilterItem} from "../../../dtos/pagination/IDataGridLoadOptionsFilterItem";
import {DataGridFilterExpressionPartTypeEnum} from "../../../dtos/pagination/DataGridFilterExpressionPartTypeEnum";
import {IListViewCreateDependedDocumentAction} from "../IListViewCreateDependedDocumentAction";
import {Button, Col, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {v4 as uuidv4} from "uuid";
import {IListViewCreateMoreActions} from "../IListViewCreateMoreAction";
import {TypeHelper} from "../../../helpers/TypeHelper";
import {addTab, ITab, removeTab} from "../../../redux/slices/newTabSlice";
import {NewDocumentModalView} from "../NewDocumentModalView";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks/hooks";
import {format} from "date-fns";
import {selectGridUpdateTrigger, setGridUpdateTrigger} from "../../../redux/slices/gridSlice";
import {setIsDetailViewOpen} from "../../../redux/slices/modalAsTabSlice";
import {toast} from "react-toastify";
import TransactionsPage from "../../Pages/Transactions/TransactionsPage";
import {TransactionService} from "../../../services/transactions/TransactionService";
import Swal from "sweetalert2";
import {IPostDocumentResponseDto} from "../../../dtos/documents/IPostDocumentResponseDto";
import {addMessage} from "../../../redux/slices/userMessageSlice";
import {NFLoadPanel} from "../NFLoadPanel";
import {IDataGridLoadOptionsSortItem} from "../../../dtos/pagination/IDataGridLoadOptionsSortItem";
import {useNavigate} from "react-router-dom";
import {ERP_dateTimeFormat} from "../../../config/appconst";
import "./ListView.css";
import DocumentsHierarchyPage from "../../Pages/DocumentsHierarchy/DocumentsHierarchyPage";
import {DocumentDetailView} from "../DetailViews/DocumentDetailView";

interface IProps {
    children?: React.ReactNode;
    fields: IListViewField[];
    entity: IAppEntity;
    createMoreActions?: IListViewCreateMoreActions[];
    createDependedDocumentActions?: IListViewCreateDependedDocumentAction[];
    createDocumentActions?: IListViewCreateDependedDocumentAction[];
}

const allowedPageSizes = [8, 12, 20];

export const ListView = ({
                             children,
                             createDocumentActions,
                             fields,
                             entity,
                             createDependedDocumentActions,
                             createMoreActions
                         }: IProps) => {
        const childrenArray = React.Children.toArray(children);
        const dispatch = useAppDispatch();
        const [clonedObject, setClonedObject] = useState<any>(null);
        const activeTabId = useAppSelector((state: any) => state.newTab.activeTab);
        const [isDetailLoading, setIsDetailLoading] = useState<boolean>(false);
        const [updatedData, setUpdatedData] = useState<string>();
        const [isFailure, setIsFailure] = useState<boolean>(false);
        const [errorMessage, setErrorMessage] = useState<string | null>(null);
        const [showDateRangeBox, setShowDateRangeBox] = useState<boolean>(false);
        const [startDate, setStartDate] = useState<Date | undefined>(undefined);
        const [endDate, setEndDate] = useState<Date | undefined>(undefined);
        const [isLoading, setIsLoading] = useState<boolean>(false);
        const [searchText, setSearchText] = useState<string>("");
        // const [gridData, setGridData] = useState<any[]>([]);
        const [createDocumentActionVisible, setCreateDocumentActionVisible] = useState<boolean>(false);
        const [createBaseAtDocumentEntity, setCreateBaseAtDocumentEntity] = useState<IAppEntity | null>(null);
        const [isDetailViewCreateBaseAtDocumentOpen, setIsDetailViewCreateBaseAtDocumentOpen] = useState<boolean>(false);
        const [createDocumentEntity, setCreateDocumentEntity] = useState<IAppEntity | null>(null);
        const [isItemSelected, setIsItemSelected] = useState<boolean>(false);
        const uniqueId = uuidv4();
        const navigate = useNavigate();
        // const [selectedItem, setSelectedItem] = useState<any | undefined>(undefined);
        const gridUpdateTrigger = useAppSelector(selectGridUpdateTrigger);

        const dataGridRef = useRef<DataGrid | null>(null);
        const {t} = useTranslation();

        const [createMoreActionsVisible, setCreateMoreActionsVisible] = useState<boolean>(false);

        const handleStartDateChange = (selectedStartDate: Date) => {
            setStartDate(selectedStartDate);
        };

        const handleEndDateChange = (selectedEndDate: Date) => {
            setEndDate(selectedEndDate);
        };
        const handleClearDates = () => {
            setStartDate(undefined);
            setEndDate(undefined);
        };
        // const fetchData = async () => {
        //     try {
        //         setIsLoading(true);
        //         const dataService = entity.getDataService();
        //         const data = await dataService.GetAll(searchText, startDate, endDate);
        //         setGridData(data);
        //     } catch (e: any) {
        //         toast.error(e.message);
        //     } finally {
        //         setIsLoading(false);
        //     }
        // };

        const store = new CustomStore({
            key: "id",
            load: async (loadOptions) => {
                const dataService = entity.getDataService();
                const response = await dataService.GetPage({
                    loadOptions: {
                        skip: loadOptions.skip,
                        take: loadOptions.take,
                        filter: convertFilter(loadOptions.filter),
                        sort: convertSort(loadOptions.sort)
                    }
                });
                return {
                    totalCount: response.totalCount,
                    data: response.items,
                    summary: [],
                    groupCount: 0
                };
            }
        });

        const RefreshGridData = async () => {
            if (showDateRangeBox) setShowDateRangeBox(false);

            // await fetchData();
        };
        useEffect(() => {
            // fetchData();
        }, [gridUpdateTrigger, searchText, startDate, endDate]);

        const convertSort = (sort: any) => {
            const result: IDataGridLoadOptionsSortItem[] = [];
            if (!sort) {
                return result;
            }

            sort.map((item: any) => {
                result.push({
                    fieldName: item.selector,
                    orderType: item.desc ? 1 : 0
                });
            });

            return result;
        };

        const convertFilter = (filter: any) => {
            const result: IDataGridLoadOptionsFilterItem[] = [];
            if (!filter) {
                return result;
            }
            filter.map((item: any) => {
                if (item === "and" || item === "or") {
                    result.push({
                        expressionPartType: DataGridFilterExpressionPartTypeEnum.Condition,
                        condition: item,
                        valueDate: null,
                        valueNumber: null,
                        valueString: null,
                        fieldName: null,
                        operator: null
                    });
                } else if (Array.isArray(item)) {
                    let valueString = null;
                    let valueNumber = null;
                    let valueDate = null;
                    if (Number.isFinite(item[2])) {
                        valueNumber = item[2];
                    } else if (item[2] instanceof Date) {
                        valueDate = item[2];
                    } else {
                        valueString = item[2] ? item[2].toString() : "";
                    }

                    result.push({
                        expressionPartType: DataGridFilterExpressionPartTypeEnum.Operator,
                        fieldName: item[0],
                        operator: item[1],
                        valueString: valueString,
                        valueNumber: valueNumber,
                        valueDate: valueDate,
                        condition: null
                    });
                }
            });

            return result;
        };

        const dataGridStatusColumnRender = useCallback((column: any) => {
            let statusName = "draft"; //cellElement.data.statusName;
            let statusColor = "black"; //cellElement.data.statusColor;
            switch (column.data.status) {
                case 0:
                    statusName = t("Draft");
                    statusColor = "black";
                    break;
                case 1:
                    statusName = t("Posted");
                    statusColor = "green";
                    break;
                case 2:
                    statusName = t("Deleted");
                    statusColor = "red";
                    break;
                default:
                    statusName = t("Draft");
                    statusColor = "black";
                    break;
            }
            return <div style={{color: statusColor}}>{statusName}</div>;
        }, []);
        const handleSelectionChanged = (e: any) => {
            if (e.selectedRowKeys && e.selectedRowKeys.length > 0) {
                setIsItemSelected(true);
            } else {
                setIsItemSelected(false);
            }
        }
        const handleCreateNewClick = () => {
            setClonedObject(undefined);
            const id = uuidv4();
            const documentDate = new Date().toLocaleString().slice(0, 9);
            const newTab: ITab = {
                id,
                title: `${entity.title} from ${documentDate}`,
                entity,
                side: "left",
                isModified: false,
                component: (
                    <DocumentDetailView entity={entity} id={undefined}/>
                )
            };
            dispatch(addTab(newTab));
        };
        const handleCloseDetailView = async (result: boolean) => {
            setIsDetailViewCreateBaseAtDocumentOpen(false);
            // setBaseObject(null);
            if (result) {
                dispatch(setGridUpdateTrigger());
            }
        };
        const handleCellDoubleClick = async (e: any) => {
            if (e.columnIndex == 0) {
                return;
            }
            await handleEditClick();
        };
        const handleCloneClick = async () => {
            const selectedRows = dataGridRef.current?.instance.getSelectedRowKeys();
            if (!selectedRows || selectedRows.length === 0) return;
            const selectedItemId = dataGridRef.current?.instance.getSelectedRowKeys()[0];
            const id = uuidv4();
            const dataService = entity.getDataService();
            const clonedObject = await dataService.Clone(selectedItemId);

            setClonedObject(clonedObject);
            dispatch(setIsDetailViewOpen(true));
            dataService.Get(selectedItemId.id).then((itemNumber: any) => {
                const newTab: ITab = {
                    id,
                    title: "",
                    entity,
                    side: "left",
                    isModified: false,
                    documentNumber: itemNumber.documentNumber,
                    documentDate: new Date(itemNumber.documentDate).toLocaleString().slice(0, 10),
                    documentStatus: itemNumber.status,
                    component: <NewDocumentModalView entity={entity} onClose={handleCloseDetailView} id={selectedItemId.id}
                                                     clonedObject={clonedObject}/>
                };
                dispatch(addTab(newTab));
            });
        };
        const handleCreateDocumentAction = async (action: IListViewCreateDependedDocumentAction) => {
            const selectedRows = dataGridRef.current?.instance.getSelectedRowKeys();
            if (!selectedRows || selectedRows.length === 0) return;
            const selectedItemId = dataGridRef.current?.instance.getSelectedRowKeys()[0];

            const clonedObject = await action.createBaseAtFunction({
                id: selectedItemId
            });
            const id = uuidv4();
            const newTab: ITab = {
                id,
                title: `${action.appEntity?.title} ${clonedObject.documentNumber} ${format(clonedObject.documentDate, "dd/MM/yyyy HH:mm")}`,
                side: "left",
                isModified: false,
                component: <NewDocumentModalView entity={action.appEntity} onClose={handleCloseDetailView}
                                                 id={selectedItemId.id} clonedObject={clonedObject}/>
            };
            dispatch(addTab(newTab));

            setCreateBaseAtDocumentEntity(action.appEntity);
            setIsDetailViewCreateBaseAtDocumentOpen(true);
            setCreateDocumentActionVisible(false);
            setCreateDocumentEntity(action.appEntity);
            // dispatch(setIsDetailViewOpen(true));
        };
        const handleEditClick = async () => {
                const selectedRows = dataGridRef.current?.instance.getSelectedRowKeys();
                if (!selectedRows || selectedRows.length === 0) return;
                const selectedItemId = dataGridRef.current?.instance.getSelectedRowKeys()[0];
                console.log("selectedItemId", selectedItemId)

                try {
                    setIsDetailLoading(true);
                    setClonedObject(undefined);
                    dispatch(setIsDetailViewOpen(true));
                    // const id = uuidv4();
                    const newTab: ITab = {
                        id: selectedItemId,
                        title: "",
                        entity,
                        side: "left",
                        isModified: false,
                        component: <DocumentDetailView entity={entity} id={selectedItemId}/>
                    }
                    dispatch(addTab(newTab));
                } catch
                    (e: any) {
                    setIsFailure(true);
                    setErrorMessage(e.message);
                    toast.error(e.message);
                } finally {
                    setIsDetailLoading(false);
                }
            }
        ;
        const handleCloseDataRangeModal = () => {
            setShowDateRangeBox(false);
        };
        const onShowPopup = () => {
            setShowDateRangeBox(true);
        };
        const handleComponentRefresh = () => {
            dispatch(setGridUpdateTrigger());
        };
        const handleTabClose = (tab: ITab) => {
            // if (event) {
            //   event.stopPropagation();
            // }
            dispatch(removeTab(tab.id));
            dispatch(setIsDetailViewOpen(false));
        };
        const handleOpenHierarchy = () => {
            const selectedItemId = dataGridRef.current?.instance.getSelectedRowKeys()[0];

            const id = uuidv4();
            const documentId = selectedItemId;
            const newTab: ITab = {
                id,
                title: `Hierarchy`,
                entity,
                side: "left",
                isModified: false,
                component: <DocumentsHierarchyPage documentId={documentId} handleTabClose={handleTabClose}
                                                   handleCloseDetailView={handleCloseDetailView}/>
            };
            dispatch(addTab(newTab));
        };
        const handleOpenMoreActions = () => {
            // if (!selectedItem) {
            //   return;
            // }
            navigate("/app/more-actions");
        };
        const handlePostDocumentClick = async () => {
            const selectedRows = dataGridRef.current?.instance.getSelectedRowKeys();
            if (!selectedRows || selectedRows.length === 0) return;

            const dataService = entity.getDataService();
            try {
                setIsLoading(true);
                setIsFailure(false);
                setErrorMessage(null);

                for (let i = 0; i < selectedRows.length; i++) {
                    const selectedItemId = selectedRows[i];
                    console.log(selectedItemId);
                    // await dataService.PostDocument(selectedItemId.id);
                    const responseDto: IPostDocumentResponseDto = await dataService.PostDocument(selectedItemId);
                    if (responseDto.success) {
                        toast("Posted successfully");
                    } else {
                        toast.error("Posting failed");
                        responseDto.validationErrors.forEach((error: string) => {
                            dispatch(
                                addMessage({
                                    message: error,
                                    type: "error",
                                    date: new Date(),
                                    markedAsRead: false
                                })
                            );
                        });
                    }
                }
                dispatch(setGridUpdateTrigger());
            } catch (e: any) {
                setIsFailure(true);
                setErrorMessage(e.message);
                toast.error(e.message);
            } finally {
                setIsLoading(false);
            }
        };
        const handleDeleteClick = async () => {
            const selectedRows = dataGridRef.current?.instance.getSelectedRowKeys();
            if (!selectedRows || selectedRows.length === 0) return;
            const selectedItemId = dataGridRef.current?.instance.getSelectedRowKeys()[0];

            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
            });

            if (result.isConfirmed) {
                const dataService = entity.getDataService();
                await dataService.Delete(selectedItemId);
                dispatch(setGridUpdateTrigger());
                await Swal.fire("Deleted!", "Your file has been deleted.", "success");
            }
        };
        const handleCancelDocumentClick = async () => {
            const selectedRows = dataGridRef.current?.instance.getSelectedRowKeys();
            if (!selectedRows || selectedRows.length === 0) return;

            const dataService = entity.getDataService();
            try {
                setIsLoading(true);
                setIsFailure(false);
                setErrorMessage(null);

                for (let i = 0; i < selectedRows.length; i++) {
                    const selectedItemId = selectedRows[i];
                    await dataService.CancelDocument(selectedItemId.id);
                }

                dispatch(setGridUpdateTrigger());
                toast.success("Documents cancelled successfully");
            } catch (e: any) {
                toast.error(e.message);
                setIsFailure(true);
                setErrorMessage(e.message);
            } finally {
                setIsLoading(false);
            }
        };
        const handleOpenDocumentTransactions = async () => {
            const selectedRows = dataGridRef.current?.instance.getSelectedRowKeys();
            if (!selectedRows || selectedRows.length === 0) return;
            const selectedItemId = dataGridRef.current?.instance.getSelectedRowKeys()[0];

            try {
                setIsDetailLoading(true);
                setIsFailure(false);
                setErrorMessage(null);
                const id = uuidv4();
                const transactionService = new TransactionService();
                const documentTransactions = await transactionService.getDocumentTransactions(selectedItemId);
                const newTab: ITab = {
                    id,
                    title: `Transactions`,
                    entity,
                    side: "left",
                    isModified: false,
                    component: <TransactionsPage documentTransactions={documentTransactions}/>
                };
                dispatch(addTab(newTab));
            } catch (e: any) {
                setIsFailure(true);
                setErrorMessage(e.message);
                toast.error("Error while getting transactions");
            } finally {
                setIsDetailLoading(false);
            }
        };
        const handleClick = () => {
            setCreateMoreActionsVisible(!createMoreActionsVisible);
        };

        return (
            <>
                <div className={"main-container container-fluid"} id={"list-documents-view-port"}>
                    <div className={"card card-body border"}>
                        <Row>
                            <Col lg={12}>
                                {childrenArray &&
                                    childrenArray.map((child: any, index) => {
                                        if (TypeHelper.checkComponentType(child, "DocumentListViewToolbar")) {
                                            return (
                                                <React.Fragment key={index}>
                                                    {React.cloneElement(child, {
                                                        onCreateNewClick: handleCreateNewClick,
                                                        onCloneClick: handleCloneClick,
                                                        onEditClick: handleEditClick,
                                                        onShowTransactionsPage: handleOpenDocumentTransactions,
                                                        onShowPopup: onShowPopup,
                                                        onDeleteClick: handleDeleteClick,
                                                        onPostClick: handlePostDocumentClick,
                                                        onCancelClick: handleCancelDocumentClick,
                                                        handleCreateDocumentAction: handleCreateDocumentAction,
                                                        createDocumentActions: createDocumentActions,
                                                        handleOpenHierarchy: handleOpenHierarchy,
                                                        handleOpenMoreActions: handleOpenMoreActions,
                                                        handleClick: handleClick,
                                                        disabled: !isItemSelected,
                                                        handleComponentRefresh: handleComponentRefresh
                                                    })}
                                                    <Popup
                                                        visible={showDateRangeBox}
                                                        onHidden={handleCloseDataRangeModal}
                                                        container={"#list-documents-view-port"}
                                                        title={"Select date range"}
                                                        height={"auto"}
                                                        width={"auto"}
                                                        hideOnOutsideClick={false}
                                                    >
                                                        <DateRangeBox
                                                            startDate={startDate}
                                                            endDate={endDate}
                                                            onStartDateChange={handleStartDateChange}
                                                            width={600}
                                                            height={50}
                                                            onEndDateChange={handleEndDateChange}
                                                        />

                                                        <div className={"d-flex mt-2"}>
                                                            <span className="flex-grow-1"></span>
                                                            <Button className="btn btn-danger" onClick={handleClearDates}>
                                                                {t("Clear")}
                                                            </Button>
                                                            <span className="px-2"></span>
                                                            <Button className="btn btn-primary" onClick={RefreshGridData}>
                                                                {t("Apply")}
                                                            </Button>
                                                            <span className="px-2"></span>
                                                            <Button className="btn btn-light"
                                                                    onClick={handleCloseDataRangeModal}>
                                                                {t("Close")}
                                                            </Button>
                                                        </div>
                                                    </Popup>
                                                    {createDocumentActions && createDocumentActions.length > 0 && (
                                                        <>
                                                            {/* <ListViewToolbarButton
                              id={`createDocumentActionsButton_${uniqueId}`}
                              caption={t("CreateDocument")}
                              onClick={handleCreateDocumentActionPopupButtonClick}
                              iconClass={"fa-solid fa-list me-2"}
                              extraClass="ms-2"
                            /> */}
                                                        </>
                                                    )}
                                                </React.Fragment>
                                            );
                                        }

                                        return <React.Fragment key={index}></React.Fragment>;
                                    })}
                            </Col>
                        </Row>
                        <div className={"my-2"}></div>
                        <DataGrid
                            onCellDblClick={handleCellDoubleClick}
                            onSelectedRowKeysChange={handleSelectionChanged}
                            dataSource={store}
                            // onRowDblClick={handleRowDoubleClick}
                            showBorders={true}
                            remoteOperations={true}
                            selection={{mode: "multiple"}}
                            ref={dataGridRef}
                            onSelectionChanged={handleSelectionChanged}
                        >
                            <Column dataField="status" dataType="string" caption={"Status"} width={75}
                                    cellRender={dataGridStatusColumnRender}/>

                            <ColumnChooser enabled={true}/>
                            <GroupPanel visible={true}/>
                            <Grouping autoExpandAll={false}/>
                            <SearchPanel visible={true} highlightCaseSensitive={true} searchVisibleColumnsOnly={true}/>
                            <Paging defaultPageSize={12}/>
                            <Pager showPageSizeSelector={true} allowedPageSizes={allowedPageSizes}/>
                            <Column dataField="documentDate" dataType="datetime" sortOrder={"asc"} sortIndex={0}
                                    cssClass={`erp-listview-column`}
                                    allowSorting={true} format={ERP_dateTimeFormat} width={200}/>
                            <Column dataField="documentNumber" dataType="string" sortOrder={"asc"} sortIndex={1}
                                    cssClass={`erp-listview-column`}
                                    width={200}/>
                            {fields.map((field, index) => (
                                <Column key={index} dataField={field.fieldName} dataType={field.fieldType}
                                        format={field.format} cssClass={`erp-listview-column ${field.cssClass} `}
                                        caption={field.title} cellRender={field.cellRender} width={field.width}/>
                            ))}
                        </DataGrid>
                    </div>
                </div>
                <NFLoadPanel isLoading={isLoading || isDetailLoading}/>
            </>
        );
    }
;
